import { Withheld } from "./Withheld";

export default function WhatWeDoNotPublish() {
  return (
    <section className="hairline py-16 rise rise-3" data-testid="what-we-do-not-publish">
      <span className="t-label">What we do not publish</span>
      <p className="t-body text-bone mt-4 measure">
        No company names, no seller names, no prices, no inventory, no listings, no logos.
        Not on this site, not anywhere.
      </p>
      <div className="grid md:grid-cols-2 gap-px mt-8 max-w-4xl" style={{ background: "#24272B" }}>
        <div className="p-6" style={{ background: "#0E1012" }} data-testid="redacted-case-1">
          <span className="t-cap text-muted-s fig">Deal log, entry 11</span>
          <p className="fig t-small text-bone mt-3 leading-7">
            Bought <Withheld w="7ch" /> shares of <Withheld w="12ch" /> from <Withheld w="9ch" /> at
            USD <Withheld w="5ch" /> per share. Issuer confirmation received. Funds wired in
            7 business days.
          </p>
        </div>
        <div className="p-6" style={{ background: "#0E1012" }} data-testid="redacted-case-2">
          <span className="t-cap text-muted-s fig">Deal log, entry 14</span>
          <p className="fig t-small text-bone mt-3 leading-7">
            Declined <Withheld w="11ch" /> at USD <Withheld w="5ch" />. The memo could not
            answer who was selling and why. We do not buy what we cannot explain.
          </p>
        </div>
      </div>
    </section>
  );
}
